import {
  FormattedCurrency,
  FormattedDate,
  Table,
  Panel
} from '@elotech/components';
import React from 'react';
import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import * as types from './Types';
import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';
import { fromJS } from 'immutable';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react';

class RenunciaReceitasList extends Component {
  constructor(props) {
    super(props);
    this.state = { sort: undefined, activeTab: '' };
  }

  static propTypes = {
    page: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    search: PropTypes.func.isRequired,
    onTabClick: PropTypes.func.isRequired,
    currentTabSearched: PropTypes.string.isRequired,
    onExport: PropTypes.func.isRequired
  };

  hasElements = () => {
    const { page } = this.props;

    return page?.get('totalElements') > 0 && page?.has('content');
  };

  getContent = () => {
    const { page } = this.props;

    return page?.get('content').toJS();
  };

  shouldShow = () => {
    const { currentTabSearched } = this.props;
    const { activeTab } = this.state;

    return this.hasElements() && activeTab && currentTabSearched === activeTab;
  };

  onTabClick = tab => {
    const { onTabClick } = this.props;

    this.setState({ activeTab: tab.name });
    onTabClick(tab);
  };

  sortOnHeaderColumnClick = sort => {
    if (!this.hasElements()) return;

    const { search, filter, page } = this.props;
    const pageWithSort = fromJS({ ...page.toJS(), ...sort });

    search(filter, pageWithSort).then(() => {
      this.setState({ sort: sort });
    });
  };

  searchWithPage = page => {
    const { search, filter } = this.props;
    const { sort } = this.state;
    const pageWithSort = fromJS({ ...page.toJS(), ...sort });

    search(filter, pageWithSort);
  };

  onExport = (exportType, openTab, windowParams) => {
    const { onExport, page } = this.props;
    const { sort } = this.state;
    const pageWithSort = fromJS({ ...page.toJS(), ...sort });

    onExport(exportType, openTab, windowParams, pageWithSort);
  };

  render() {
    const { page } = this.props;
    const {
      onExport,
      onTabClick,
      shouldShow,
      getContent,
      searchWithPage,
      sortOnHeaderColumnClick
    } = this;

    return (
      <Panel isTable scrollHorizontal visible={true}>
        <ExportButtonGroup onClick={onExport} visible={true} />
        <Tabs onTabClick={onTabClick}>
          {types.RenunciaReceitas.map(item => (
            <Tab key={item.tipo} name={item.tipo} title={item.label}>
              <Table
                keyExtractor={(_, index) => index}
                values={shouldShow() ? getContent() : []}
                sortOnHeaderColumnClick={sortOnHeaderColumnClick}
              >
                <Table.Column
                  sortable
                  name="dataSituacao"
                  header="Data"
                  value={value => <FormattedDate value={value.dataSituacao} />}
                />
                <Table.Column
                  sortable
                  name="cpfCnpj"
                  header="CPF/CNPJ"
                  value={value => value.cpfCnpj}
                />
                <Table.Column
                  sortable
                  name="contribuinte"
                  header="Contribuinte"
                  value={value => value.contribuinte}
                />
                <Table.Column
                  sortable
                  name="especie"
                  header="Espécie"
                  value={value => value.especie}
                />
                <Table.Column
                  sortable
                  name="justificativa"
                  header="Justificativa"
                  value={value => value.justificativa}
                />
                <Table.Column
                  sortable
                  name="valor"
                  header="Valor"
                  value={value => <FormattedCurrency value={value.valor} />}
                />
              </Table>
            </Tab>
          ))}
        </Tabs>
        {shouldShow() && (
          <SearchPagination page={page} searchWithPage={searchWithPage} />
        )}
      </Panel>
    );
  }
}

export default RenunciaReceitasList;
